import React, { useState, useEffect } from "react";
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import axios from "axios";
import { MdWavingHand } from "react-icons/md";
import WelcomeImage from "../images/profile/marketer_welcome.png";
import { buildApiUrl } from "../utils/api";

function MarketerDetails() {
    const [userName, setUserName] = useState('');

    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) return;

                const res = await axios.get(buildApiUrl('/api/marketer/marketerDetails'), {
                    headers: { Authorization: `Bearer ${token}` }
                });

                if (res.data?.user) {
                    setUserName(res.data.user.name || '');
                }
            } catch (error) {
                console.error('Error fetching marketer details:', error);
            }
        };

        fetchUserDetails();
    }, []);

    return (
        <>
            <Helmet>
                <title>Marketer Dashboard | 3PL Search</title>
            </Helmet>
            <div className="marketerDetail p-3">
                <h2>Welcome, {userName || "CS Agent"} <MdWavingHand style={{ color: "#E0A75E" }} /></h2>
                <p className="text-muted mb-4">Manage enquiries, review buyer briefs, and track quote progression.</p>

                <div className="row g-3 mb-4">
                    <div className="col-sm-6 col-md-3">
                        <Link to="/marketerDetails/commonEnquiryList" style={{ textDecoration: "none" }}>
                            <div className="card h-100 border-0 shadow-sm p-3 text-center">
                                <h6 style={{ color: "#132238" }}>Contact Enquiries</h6>
                                <p className="text-muted small">View and manage inbound contact form enquiries.</p>
                            </div>
                        </Link>
                    </div>
                    <div className="col-sm-6 col-md-3">
                        <Link to="/marketerDetails/userBookingList" style={{ textDecoration: "none" }}>
                            <div className="card h-100 border-0 shadow-sm p-3 text-center">
                                <h6 style={{ color: "#132238" }}>Quote Requests</h6>
                                <p className="text-muted small">Review and progress warehouse quote requests.</p>
                            </div>
                        </Link>
                    </div>
                    <div className="col-sm-6 col-md-3">
                        <Link to="/marketerDetails/warehouseEnquiryList" style={{ textDecoration: "none" }}>
                            <div className="card h-100 border-0 shadow-sm p-3 text-center">
                                <h6 style={{ color: "#132238" }}>Buyer Briefs</h6>
                                <p className="text-muted small">Review guided buyer briefs submitted from the booking form.</p>
                            </div>
                        </Link>
                    </div>
                    <div className="col-sm-6 col-md-3">
                        <Link to="/marketerDetails/clientEnquiryList" style={{ textDecoration: "none" }}>
                            <div className="card h-100 border-0 shadow-sm p-3 text-center">
                                <h6 style={{ color: "#132238" }}>Provider Applications</h6>
                                <p className="text-muted small">View providers who have applied to list on the platform.</p>
                            </div>
                        </Link>
                    </div>
                </div>

                <div className="text-center" style={{ opacity: 0.5, maxWidth: "360px" }}>
                    <img src={WelcomeImage} alt="marketer welcome" style={{ width: "100%" }} />
                </div>
            </div>
        </>
    );
}

export default MarketerDetails;
